import CryptoJS from 'crypto-js';

const passphrase = String(process.env.REACT_APP_TOKEN_PASS);

export function encryptText(plaintext:string) {
  const encrypted = CryptoJS.AES.encrypt(plaintext, passphrase).toString();
  return encrypted;
}

export function decryptText(encryptedText:string) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, passphrase);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (error) {
    return "";
  }
}
